// src/components/LoginPage.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword, createUserWithEmailAndPassword, sendPasswordResetEmail } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { auth, db } from "../firebase";
import AppHeader from "./AppHeader";

const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isNewUser, setIsNewUser] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      if (isNewUser) {
        const userCred = await createUserWithEmailAndPassword(auth, email, password);

        // Create empty user & book docs on signup
        await setDoc(doc(db, "users", userCred.user.uid), { email });
        await setDoc(doc(db, "books", userCred.user.uid), {
          authorName: "",
          bookTitle: "",
          contents: [],
          published: false
        });

        navigate("/create-book");
      } else {
        await signInWithEmailAndPassword(auth, email, password);
        navigate("/manage-book");
      }
    } catch (err) {
      setError(err.message);
    }
    };

    const handleForgotPassword = async () => {
        if (!email) {
            setError("Please enter your email first.");
            return;
        }
        try {
            setError("");
            await sendPasswordResetEmail(auth, email);
            alert("Password reset email sent! Please check your spam folder if you don't see it in your inbox within 2 minutes.");
        } catch (err) {
            setError(err.message);
        }
    };

  return (
    <div className="container mt-5" style={{ maxWidth: 400 }}>
    <AppHeader />
      <h2 className="mb-4 text-center">{isNewUser ? "Sign Up" : "Login"}</h2>
      {error && <div className="alert alert-danger">{error}</div>}
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label>Email</label>
          <input type="email" className="form-control" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div className="mb-3">
          <label>Password</label>
          <input type="password" className="form-control" required value={password} onChange={(e) => setPassword(e.target.value)} />
              </div>
        <button className="btn btn-primary w-100" type="submit">
          {isNewUser ? "Create Account" : "Login"}
              </button>
              {!isNewUser && (
                  <div className="text-end">
                      <button
                          type="button"
                          className="btn btn-link p-0"
                          onClick={handleForgotPassword}
                      >
                          Forgot password?
                      </button>
                  </div>
              )}
        <div className="text-center mt-3">
          <button type="button" className="btn btn-link" onClick={() => setIsNewUser(!isNewUser)}>
            {isNewUser ? "Already have an account? Login" : "New here? Create an account"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default LoginPage;
